export default "__VITE_ASSET__D6NUHPJc__"